module.exports = __webpack_public_path__ + "img/pd-img31.43e9806e.jpg";